var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronRight = function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    focusable: false
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M591 512 277 826q-21 21-21 51.5t21 51.5q22 22 52 22t52-22l366-365q21-21 21-51.5T747 461L381 95q-22-22-52-22t-52 22q-21 21-21 51.5t21 51.5l314 314z"
  })));
};
export { SvgChevronRight as ReactComponent };
export default __webpack_public_path__ + "275252fe10db35a917c182033b11f9b5.svg";